type RecordWithRepeats<T> = { [k: string]: T | T[] };
type RecordWithoutRepeats<T> = { [k: string]: T };
type RecordWithUndefined<T> = { [k: string]: T | undefined };

export const ignoreRepeats = <T>(
  map: RecordWithRepeats<T>,
): RecordWithoutRepeats<T> => {
  return Object.entries(map).reduce(
    (result: RecordWithoutRepeats<T>, curr: [string, T | T[]]) => {
      const [k, v] = curr;
      let val;
      if (Array.isArray(v)) {
        console.error("key", k, "occurs multiple times; using first");
        val = v[0];
      } else {
        val = v;
      }
      result[k] = val;

      return result;
    },
    {},
  );
};

// Return new map merging entries of a and b (with b superseding a),
// and skipping any entries whose key is present in b but whose value
// is undefined.
export const mergeDelete = <T>(
  a: RecordWithoutRepeats<T>,
  b: RecordWithUndefined<T>,
): RecordWithoutRepeats<T> => {
  const merged = { ...a, ...b };
  Object.entries(b).forEach(([k, v]) => {
    if (v === undefined) {
      delete merged[k];
    }
  });
  // We explicitly remove all keys with undefined values, so this is safe.
  // There may be a better way to express this in the type system.
  return merged as RecordWithoutRepeats<T>;
};
